import { render, staticRenderFns } from "./MaxPurchaseQuantity.vue?vue&type=template&id=f5cb7448&scoped=true&"
import script from "./MaxPurchaseQuantity.vue?vue&type=script&lang=ts&"
export * from "./MaxPurchaseQuantity.vue?vue&type=script&lang=ts&"
import style0 from "./MaxPurchaseQuantity.vue?vue&type=style&index=0&id=f5cb7448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb7448",
  null
  
)

export default component.exports